/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Agen_TInputs */

const en_mk_tut_agen_t = /** @type {(inputs: Mk_Tut_Agen_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assigning an agent and reading what it did`)
};

const id_mk_tut_agen_t = /** @type {(inputs: Mk_Tut_Agen_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menugaskan agen dan membaca hasilnya`)
};

/**
* | output |
* | --- |
* | "Assigning an agent and reading what it did" |
*
* @param {Mk_Tut_Agen_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_agen_t = /** @type {((inputs?: Mk_Tut_Agen_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Agen_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_agen_t(inputs)
	return en_mk_tut_agen_t(inputs)
});